<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h3 v-if="isMapping">
              Mapping Siswa
            </h3>
            <h3 v-else>
              Bulk Activation / Registration Upload .CSV
            </h3>
          </div>

          <div class="modal-body">
            <slot name="body">
              <form>
                <div class="form-horizontal form-bordered">
                  <div class="form-group">
                    <label class="col-md-2 control-label">Duration (bulan) <span style="color: red">*</span></label>
                    <div class="col-md-8 col-xs-12">
                      <select v-model="data.duration" class="form-control">
                        <!-- <option>0</option> -->
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                        <option>11</option>
                        <option>12</option>
                      </select>
                    </div>
                  </div>
                  <div v-if="!isMapping" class="form-group">
                    <label class="col-md-2 control-label">File <span style="color: red">*</span></label>
                    <div class="col-md-8 col-xs-12">
                      <div class="row">
                        <div v-if="filename" class="col-md-4">
                          <p>{{ filename }}</p>
                        </div>
                        <div class="col-md-8">
                          <div id="fileupload">
                            <label class="btn btn-white">
                              <i class="fa fa-paperclip">
                                <input
                                  type="file"
                                  @change="upload"
                                  style="display:none"
                                  accept=".csv" />
                              </i>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <section v-if="!isMapping">
                  <div class="form-group">
                      <label class="col-md-2 control-label">Password</label>
                      <div class="col-md-8 col-xs-12" style="position:relative;">
                        <input v-if="hidePass" type="password" v-model="data.default_password" class="form-control"/>
                        <input v-if="!hidePass" type="text" v-model="data.default_password" class="form-control"/>
                        <i v-if="hidePass" @click="hidePass = false" class="fa fa-eye eyeicon"></i>
                        <i v-if="!hidePass" @click="hidePass = true" class="fa fa-eye-slash eyeicon"></i>
                      </div>
                    </div>
                  <div class="form-group">
                      <label class="col-md-2 control-label">Kelas</label>
                      <div class="col-md-4 col-xs-12">
                        <select
                          v-model="jenjang"
                          class="form-control"
                        >
                          <option value="SD">SD</option>
                          <option value="SMP">SMP</option>
                          <option value="SMA">SMA</option>
                        </select>
                      </div>
                      <div class="col-md-4 col-xs-12">
                        <select
                          v-model="grade"
                          class="form-control"
                        >
                          <option
                            v-for="(item, index) in jenjangList"
                            v-bind:key="index"
                            :value="item"
                          >
                            {{item}}
                          </option>
                        </select>
                      </div>
                    </div>
                  <div class="form-group">
                      <label class="col-md-2 control-label">Fitur</label>
                      <div
                        class="col-md-4 col-xs-12"
                        style="display:flex; flex-flow:column;"
                      >
                        <!-- <input type="checkbox" class="form-control" v-model="data.features"> -->
                        <span
                          v-for="(item, index) in featureList"
                          v-bind:key="index"
                        >
                          <input
                            type="checkbox"
                            class="checkbox m-r-5"
                            v-model="features"
                            :value="item"
                          ><span class="f-s-14 f-w-700 m-r-10">
                            {{item === 'INSTANT_TRYOUT' ? 'Tryout Instan': item === 'CONSULTATION' ? 'Konsultasi' : item === 'DUEL' ? 'Duel': item === 'ITEM_BANK' ? 'Bank Soal' : item === 'SCHEDULED_TRYOUT' ? 'Tryout Terjadwal' : item === 'VIDEO' ? 'Video Pembelajaran' : item === 'BIMBEL' ? 'Bimbel' : ''}}
                          </span>
                        </span>
                        <span>
                          <input
                            type="checkbox"
                            class="checkbox m-r-5"
                            v-model="featBimbel"
                            value="true"
                          ><span class="f-s-14 f-w-700 m-r-10">Bimbel</span>
                        </span>
                      </div>

                      <div
                        class="col-md-6 col-xs-12"
                        style="display:flex; flex-flow:column; max-height: 200px; overflow:auto"
                        v-if="featBimbel"
                      >
                        <span>
                          <h5>Pilih Daftar Bimbel</h5>
                        </span>
                        <span v-if="bimbelList.length === 0">Tidak ada bimbel yang bisa dipilih <br />Silahkan pilih kelas lain atau buat bimbel baru</span>
                        <span
                          v-for="(item,index) in bimbelList"
                          v-bind:key="index"
                        >
                          <input
                            type="checkbox"
                            class="checkbox m-r-5"
                            v-model="bimbels"
                            :value="item.id"
                          ><span class="f-s-14 f-w-700 m-r-10">{{item.name}}</span>
                        </span>
                      </div>
                    </div>
                  </section>
                </div>
              </form>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-primary" @click="$emit('close')">
                Cancel
              </button>
              <a v-if="!isMapping" class="btn btn-success" :href="ossTemplate" target="_blank">
                Download Example CSV
              </a>
              <button v-if="isMapping" class="btn btn-success" :disabled="!data.duration" @click="$emit('submitMapping', data.duration)">
                Submit
              </button>
              
              <button v-else :disabled="!data.duration || !filename" class="btn btn-success" @click="submitBulkActivation">
                Submit
              </button>
            </slot>
          </div>

          <app-spinner v-if="isLoadActivationAsyncProgress"></app-spinner>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import AWS from 'aws-sdk'
import uniqid from 'uniqid'
import FileUpload from '@/components/plugins/FileUpload'
import AppSpinner from '@/components/plugins/Spinner'
import BimbelService from '@/services/bimbel.js'

export default {
  name: 'OrganizationsBulk',
  components: {
    FileUpload,
    AppSpinner
  },
  props: {
    isMapping: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filename: '',
      data: {
        key_name: '',
        organization_id: this.$route.params.id,
        duration: 1,
        features: '',
        grade: 0,
        default_password: ''
      },

      ossTemplate: 'https://' + process.env.OSS_BUCKET_NAME + '.' + process.env.OSS_ENDPOINT + '/assets/organizations/template.csv',
      isLoadActivationAsyncProgress: false,

      jenjangList: [],
      jenjang: '',
      grade: 0,
      hidePass: true,
            // boolean modelnya checkbox bimbel
      featBimbel: false,
      // variable yang menyimpan list bimbel yang di get dri api
      bimbelList: [],
      // daftar bimbel yg dipilih masuk ke variable ini
      bimbels: [],
      // bimbel di pisah karena punya behavior yang berbeda
      featureList: [
        'SCHEDULED_TRYOUT',
        'INSTANT_TRYOUT',
        //    'DUEL',
        //    'CONSULTATION',
        'ITEM_BANK',
        'VIDEO',
        // 'BIMBEL'
      ],
      features: [],
    }
  },
  watch: {
    jenjang: function (to, from) {
      if (to === 'SD') this.jenjangList = [4, 5, 6]
      if (to === 'SMP') this.jenjangList = [7, 8, 9]
      if (to === 'SMA') this.jenjangList = [10, 11, 12]
    },
    featBimbel: function (to, from) {
      if (to) {
        this.getBimbel()
      } else {
        this.bimbelList = []
        this.bimbels = []
      }
    },
    grade: function (to, from) {
      // console.log(to)
      this.data.features = []
      this.featBimbel = false
    },
    isLoadActivationAsyncProgress (value) {
      if (value === false) {
        clearInterval(this.interval)
        this.$emit('close')
      }
    }
  },
  methods: {
    getBimbel: function () {
      var context = this
      if (this.grade === 0) this.grade = 12
      BimbelService.statPublishedBimbel(this.grade, function (result) {
        context.bimbelList = result.data
      })
    },
    upload: function(e) {
      console.log(e)
      var file = e.target.files[0]

      console.log('file: ', file)

      if(!file) return
      // if(file.type.indexOf('csv') == -1 &&
      //    file.type.indexOf('ms-excel') == -1) {
      //   alert('file type not supported')
      //   return
      // }

      AWS.config.accessKeyId = process.env.OSS_KEY
      AWS.config.secretAccessKey= process.env.OSS_SECRET
      var spaceEndpoint = process.env.OSS_ENDPOINT
      var bucket = new AWS.S3({
        endpoint: spaceEndpoint
      })

      var fileExt = file.name.substr(-4)
      var filename = uniqid() + fileExt
      var params = {
        Bucket: process.env.OSS_BUCKET_NAME,
        Key: 'assets/organizations/' + filename,
        Body: file,
        ContentType: file.type,
        ACL: 'public-read'
      }

      var context = this
      bucket.upload(params, function(error, data) {
        if(error) {
          console.error(error)
        } else {
          context.filename = file.name
          context.data.key_name = data.key
        }
      })
    },
    submitBulkActivation () {
      var token = this.$ls.get('token');
      var context = this
      var url = process.env.API_BASE_URL + '/account/register/bulk'

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      if(this.featBimbel && this.bimbels.length > 0) {
          var bbl = ','
          this.bimbels.forEach(element => {
            bbl += element + ','
          })
          this.features.push('BIMBEL'+ bbl)
      }
      if(this.features.length > 0) {
        this.features.forEach(element => {
          this.data.features += element + ','
        })
      }
      this.data.grade = this.grade
		  this.data.features = this.data.features.slice(0, -1)
      this.data.organization_id = parseInt(this.data.organization_id)
      if(this.data.features.length == 0) this.data.features = null
      http.post(url, context.data)
      .then((response) => {
        const activationId = response.data.id
        this.loadActivationAsyncProgress(activationId)
      })
      .catch((error) => console.log(error.response.data))
    },
    loadActivationAsyncProgress (activationId) {
      this.isLoadActivationAsyncProgress = true

      this.interval = setInterval(() => {
        var token = JSON.parse(localStorage.getItem('token'))
        var url = process.env.API_BASE_URL + '/account/job/' + activationId

        var http = axios.create({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token.value
          }
        })

        http.get(url)
          .then((response) => {
            const data = response.data

            if (data.status.toLowerCase() === 'finished') {
              this.isLoadActivationAsyncProgress = false
              this.$emit('reload')
              alert('Bulk Activation Success')
            }

            if (data.status.toLowerCase() === 'failed') {
              this.isLoadActivationAsyncProgress = false
              alert('Bulk Activation Error!')
            }
          })
          .catch(() => {
            this.isLoadActivationAsyncProgress = false
            alert('Bulk Activation Error!')
          })
      }, 10000)
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 700px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #000000;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.eyeicon {
    position: absolute;
    top: 38%;
    right: 28px;
    color: black;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// OrganizationsBulk.vue?7c177b6a